import {FC, useEffect, useState} from 'react'
import Select from 'react-select'
import {getAll} from '../../../../services/common_requests'

interface Props {
  selected: string
  onChange: (lang: string) => void
}

interface LanguageOption {
  value: string
  label: string
  flag: string
}

const LANGUAGE_NAMES: Record<string, string> = {
  fr: 'Français',
  en: 'English',
  es: 'Español',
  ar: 'العربية',
}

const FLAG_MAPPING: Record<string, string> = {
  fr: '/media/flags/france.svg',
  en: '/media/flags/united-states.svg',
  es: '/media/flags/spain.svg',
  ar: '/media/flags/arabic.svg',
}

const LanguageSelector: FC<Props> = ({selected, onChange}) => {
  const [languages, setLanguages] = useState<LanguageOption[]>([])

  useEffect(() => {
    getAll({}, '/languages').then((data) => {
      if (Array.isArray(data)) {
        const formatted = data.map((code: string) => ({
          value: code, // Remplace "code" par "value" pour React-Select
          label: LANGUAGE_NAMES[code] || code.toUpperCase(),
          flag: FLAG_MAPPING[code] || '',
        }))
        setLanguages(formatted)
      }
    })
  }, [])

  return (
    <div style={{width: '30%'}}>
      <Select<LanguageOption>
        className='fs-8  py-2 '
        options={languages}
        value={languages.find((lang) => lang.value === selected)}
        onChange={(selectedOption: LanguageOption | null) => onChange(selectedOption?.value || '')}
        getOptionLabel={(option: LanguageOption) => (
          <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
            <img src={option.flag} alt={option.label} width={20} height={15} />
            {option.label}
          </div>
        )}
      />
    </div>
  )
}

export {LanguageSelector}
